export const CPF_CNPJ_REGEX = /^(?:\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}|\d{14}|[A-Z0-9]{12}\d{2}|[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2})$/i;
export const FORMAT_DATETIME_REGEX = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/\d{4} (0\d|1\d|2[0-3]):([0-5]\d)$|^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/\d{4} às (0\d|1\d|2[0-3]):([0-5]\d)$/;

export const CNPJ_MASK = [
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '.',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '.',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '/',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '-',
  /\d/,
  /\d/,
];

export const CPF_MASK = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];

export const CPF_MASK_ALPHANUMERIC = [
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '.',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '.',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '-',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
];

export const DOC_MASK = [
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
];

export const CNPJ_DIGITS_LENGTH = 14;
export const CNPJ_LENGTH = 18;
export const CPF_DIGITS_LENGTH = 11;
export const CPF_LENGTH = 14;

export const RG_MASK = [
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/
];

export const PIS_MASK = [
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
];

export const CNH_MASK = [
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
];

export const CNH_TYPES = [
  { label: 'A' },
  { label: 'AB' },
  { label: 'AC' },
  { label: 'AD' },
  { label: 'AE' },
  { label: 'B' },
  { label: 'C' },
  { label: 'D' },
  { label: 'E' },
];

export const CARD_NUMBER = [
  /[0-9]/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const HOME_TYPES = [
  { label: 'Outros' },
  { label: 'Próprio' },
  { label: 'Alugado' },
  { label: 'Financiado' },
];

export const ADDRESS_TYPES = [
  { label: 'Casa' },
  { label: 'Apartamento' },
  { label: 'Zonal Rural' }
];

export const CIVIL_STATUS = [
  {
    value: 3,
    label: 'Solteiro',
  },
  {
    value: 2,
    label: 'Casado',
  },
  {
    value: 1003,
    label: 'Divorciado',
  },
  {
    value: 1,
    label: 'Viúvo',
  },
];

export const DATE_MASK = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const TIME_MASK = [
  /\d/,
  /\d/,
  ':',
  /\d/,
  /\d/
];

export const DATETIME_MASK = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  ':',
  /\d/,
  /\d/
];

export const DUE_DATE_MASK = [
  /[0-1]/,
  /[0-9]/,
  '/',
  /[2]/,
  /[0-0]/,
  /[2-2]/,
  /[1-9]/
];

export const CF_MASK = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];

export const CF_SLUGS = [
  'CF_COMPLEMENTAR',
  'CF_MANUAL'
];

export const PHONE_MASK = [
  '(',
  /[0-9]/,
  /\d/,
  ')',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const PHONE_MASK_AR = [
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
];

export const PHONE_MASK_PY = [
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/
];

export const PHONE_MASK_UY = [
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/
];

export const PHONE_MASK_DF = [
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
];

export const PROPERTY_TYPES = [
  { value: 'casa', label: 'Casa' },
  { value: 'apartamento', label: 'Apartamento' },
  { value: 'zona rural', label: 'Zona rural' },
];

export const PROPERTY_STATUS = [
  { value: 'proprio', label: 'Próprio' },
  { value: 'alugado', label: 'Alugado' },
  { value: 'financiado', label: 'Financiado' },
  { value: 'outros', label: 'Outros' },
];

export const GENDER_OPTIONS = [
  { value: 'F', label: 'Feminino' },
  { value: 'M', label: 'Masculino' },
];

export const REQUEST_TYPE_OPTIONS = [
  { label: 'Veículo', value: 1 },
  { label: 'Motorista', value: 2 },
  { label: 'Transportadora', value: 3 },
];
